fx.ns("shared.component", class Person extends fx.components.Box{
    
	constructor(asset, className)
	{
		super("Person");

        this._asset = asset || fx.assets.personAdvice;
        this._className = className || "image";
        this._spinning = false;
    }

    get person()
    {
        return this._person;
    }

    get src()
    {
        return this.person ? this.person.src : null;
    }

    set src(val)
    {
        if (Utils.isValidHttpUrl(val))
        {
        //if (this.person)
            this.person.src = val;
            this.person.cover = true;
        }
        else
        {
            this.person.data = val;
            this.person.cover = false;
        }
            //this._asset = val;
    }

    get spinning()
    {
        return this._spinning;
    }

    set spinning(val)
    {
        this._spinning = val;
        this._updateSpinning();
    }

    create()
    {
        super.create();

        this._person = new fx.components.Image({data : this._asset, className : this._className});
		this._circle1 = new fx.components.Box("circle1");
		this._circle2 = new fx.components.Box("circle2");
        
		this.addChild(this._circle1);
		this.addChild(this._circle2);

		this.addChild(this._person);
    }

    onReady()
    {
        this._updateSpinning();
    }

    _updateSpinning()
    {
        if (!this.initialized) return;
        
        // add animation with transform : rotate()
        // and dashed border on both circles
        this.toggleClass("spinning", this.spinning);        
        
    }

});